import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { RegulatoryGroups } from "./RegulatoryGroups.jsx";
import RegulatoryEvents from "./RegulatoryEvents.jsx";
import Card from "../../../components/Cards/Card.jsx";
import { useTranslation } from "react-i18next";

const RegulatoryContainer = (props) => {
  const { t } = useTranslation();

  return (
    <Card
      content={
        <div style={{ marginTop: "10px" }}>
          <Tabs
            defaultActiveKey="regulatory-events"
            id="regulatory-events"
            mountOnEnter={true}
          >
            <Tab
              eventKey={"regulatory-events"}
              title={t("regulatorySubmissions.tableTitle")}
            >
              <RegulatoryEvents {...props} expandedAll={true} />
            </Tab>
            <Tab eventKey={"regulatory-groups"} title="Grupos">
              <RegulatoryGroups {...props} expandedAll={true} />
            </Tab>
          </Tabs>
        </div>
      }
    />
  );
};

export default RegulatoryContainer;
